import { useState } from "react";
import { MessageSquare, FileText } from "lucide-react";
import FeedbacksTab from "./FeedbacksTab";
import TechnicalNotesTab from "./TechnicalNotesTab";

const ExpertiseTab = () => {
  const [activeSubTab, setActiveSubTab] = useState<'feedbacks' | 'technical-notes'>('feedbacks');

  return (
    <div>
      <div className="mb-6 flex justify-start">
        <div className="inline-flex rounded-full bg-gray-100 p-1 dark:bg-navy-800">
          <button
            onClick={() => setActiveSubTab('feedbacks')}
            className={`flex items-center gap-2 rounded-full px-4 py-2 text-sm font-medium transition-all duration-200 ${
              activeSubTab === 'feedbacks'
                ? "bg-white text-brand-500 shadow-sm dark:bg-navy-700 dark:text-brand-400"
                : "text-gray-600 hover:text-gray-800 hover:bg-gray-50 dark:text-gray-400 dark:hover:text-gray-200 dark:hover:bg-navy-700"
            }`}
          >
            <MessageSquare className="h-4 w-4" />
            Feedbacks
          </button>
          <button
            onClick={() => setActiveSubTab('technical-notes')}
            className={`flex items-center gap-2 rounded-full px-4 py-2 text-sm font-medium transition-all duration-200 ${
              activeSubTab === 'technical-notes'
                ? "bg-white text-brand-500 shadow-sm dark:bg-navy-700 dark:text-brand-400"
                : "text-gray-600 hover:text-gray-800 hover:bg-gray-50 dark:text-gray-400 dark:hover:text-gray-200 dark:hover:bg-navy-700"
            }`}
          >
            <FileText className="h-4 w-4" />
            Technical Notes
          </button>
        </div>
      </div>

      {/* Subtab Content */}
      {activeSubTab === 'feedbacks' && <FeedbacksTab />}
      {activeSubTab === 'technical-notes' && <TechnicalNotesTab />}
    </div>
  );
};

export default ExpertiseTab;